import {
  ContentRoute,
  createMapper,
  RouteSlotInput,
  StoryContentGroup,
} from '@caritas/ui';

import { mapImage } from '../Image.mappers';
import { mapHtmlBlock } from './HtmlBlock.mappers';

const mapImageStoryContent = createMapper<
  Array<ImageStoryContentFragment>,
  RouteSlotInput<typeof StoryContentGroup, 'items'>
>({
  BlockHtmlParagraph: mapHtmlBlock,
  BlockHtmlList: mapHtmlBlock,
});

export function mapImageStory(
  input: BlockImageStoryFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'storyBlock'> {
  return {
    key: 'storyBlock',
    input: () => [
      {
        Image: mapImage({
          image: input.imageStoryImage?.image,
          preset: 'image_story',
          caption: input.imageStoryImage?.caption,
        }),
        content: {
          items: mapImageStoryContent(input['imageStoryContent'] || []),
        },
        textPosition: input.imageStoryTextPosition || 'left',
        source: input.displaySource ? input.imageStoryImage?.source : '',
      },
      200,
    ],
  };
}
